import { Button } from '@ui/themed';
import { useHandlers, useSite } from '../context/page-context';
import { trackUpgradeClicked } from '../lib/mixpanel';

// Replaces a setting's toggle when the store's plan doesn't include the feature.
export function PlanUpgradePrompt({
  availabilityLabel,
  changePlanLabel,
  trackingLabel,
}: {
  availabilityLabel: string;
  changePlanLabel: string;
  /** Mixpanel label, so upgrades can be attributed to the feature that prompted them. */
  trackingLabel: string;
}) {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  return (
    <div className="hidden flex-col items-end pl-6 text-right lg:flex">
      <div className="-mb-0.5 flex items-center text-gray-500 text-xs">{availabilityLabel}</div>
      <Button
        variant="bare"
        size="xs"
        icon="externalLink"
        onClick={() => {
          trackUpgradeClicked(site, trackingLabel);
          navigationHandler.navigateById('plan');
        }}
      >
        {changePlanLabel}
      </Button>
    </div>
  );
}
